import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'extractinviteename' })

export class getextractinviteenamepipe implements PipeTransform
{
    //**************************************************************
    transform( val: string, searchtype: number )
        {
            var strinput: string;
            var strfirst: string;
            var n: number;

            strinput = val;

            switch ( searchtype )
                {
                    case 1:
                        {
                            n        = strinput.search("Invite Id:");
                            strfirst = 'Invitation List';
                            break;
                        }

                    case 5: 
                        {
                            n        = strinput.search("Table Id:");
                            strfirst = 'Table List';
                            break;    
                        }

                    
                    case 10: 
                        {
                            n        = strinput.search("Thankyou Id:");
                            strfirst = 'Thankyou List';
                            break;    
                        }

                    case 15: 
                        {
                            n        =  1
                            strfirst = 'TBC';
                            break;    
                        }

                }

            if ( n != 0 )
                {

                    switch ( searchtype )
                        {
                            case 15:
                                    {
                                        let invitationlistid = val.split('#');    
                                        strinput = invitationlistid[0];
                                        strinput = strinput.trim();
                                        break;
                                    }

                            default:
                                    {
                                        let invitationlistid = val.split('-');    
                                        strinput = invitationlistid[0];
                                        strinput = strinput.trim();
                                        break;
                                    }
                        }
                }
            else
                {
                    strinput = strfirst;
                }
            
          
            return strinput;
        }    
    //**************************************************************             
}